/**
 * 数科-臻有钱我的页-营销位 - 通过广告投放系统接入 https://fat-admaster.hellobike.cn/#/ssp/operation-mng
 * 广告位信息
 * 名称:数科-臻有钱我的页-营销位
 * uuid:b40ffe6b6d3d44eda02218fee2bc4d2d
 */
import { Vue, Component } from 'vue-property-decorator';
import AdvCommonContainer from '../adv-common-container';
import style from './index.module.scss';

@Component
export default class AdvMyProfileBanner extends Vue {
  private render() {
    return (
      <AdvCommonContainer
        advMasterId="b40ffe6b6d3d44eda02218fee2bc4d2d"
        customClassName={style.bannerList}
      />

    );
  }
}
